var _style, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSdlogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 383 444",
    width: 383,
    height: 444,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m10.6 8.1l-3.2 246.4 185.7 181.4 182.4-181.4v-246.4zm353.8 241.3l-172.5 170.1-172.6-170.1v-230.2h345.1c0 0 0 230.2 0 230.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "a",
    d: "m34.9 32.2h149.6v100.8l-48.1-51.6h-53.4l101.5 102.4v207.6l-149.6-149.3v-78.8l101.5 100.8v-56.1l-101.5-98.8v-77z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m200.9 32.2v359.3l148.1-149.4 1.6-209.9h-149.7zm99.3 175.5l-49.2 54.5v-180.8h49.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSdlogo);
export default __webpack_public_path__ + "static/media/sdlogo.4009ccea1ec0496b8ed4635d920167d2.svg";
export { ForwardRef as ReactComponent };